import axios from "axios";
import { HEADERS } from "../../../API/UrlAndPaths";
import store from "../../../Redux/store";
import {
  setAlertMessage,
  setIsLoading,
  setKotOrderList,
  setSideMenuList,
} from "./kitchenOrderTicketSlice";
import { alertMessages } from "../FloorManagement/utils/floorManagementEnum";
import { actionKeyName } from "./utils/kotEnum";
import { setTableLoadingGlobal } from "../../../Redux/Dashboard/mainDashBoardSlice";
import db from "../../../offline/db";

//list KOT orders API with offline support
export const listKotOrderAPI = async (obj) => {
  store.dispatch(setTableLoadingGlobal(true))
  try {
    const result = await axios.post(
      "pos/viewKotOrdersWithFilter",
      obj.body,
      HEADERS
    );
    if (result.status === 200) {
      store.dispatch(setTableLoadingGlobal(false))
      store.dispatch(setIsLoading(false));
      store.dispatch(setKotOrderList(result.data));
      
      // Cache orders for offline use
      if (result.data && Array.isArray(result.data)) {
        result.data.forEach(order => {
          db.cacheOrder(order);
        });
        console.log(`💾 KOT: Cached ${result.data.length} orders`);
      }
    }
  } catch (error) {
    // If network error, try to load from IndexedDB
    if (!error.response) {
      console.log('📴 KOT: Backend offline, loading from IndexedDB...');
      try {
        const offlineOrders = await db.getKotOrders(obj.body.branchId, obj.body.status);
        store.dispatch(setKotOrderList(offlineOrders));
        store.dispatch(setTableLoadingGlobal(false));
        store.dispatch(setIsLoading(false));
        console.log(`✅ KOT: Loaded ${offlineOrders.length} orders from offline cache`);
        
        // Show offline indicator
        store.dispatch(
          setAlertMessage({
            status: "warning",
            message: `Offline mode: Showing ${offlineOrders.length} cached orders`,
          })
        );
      } catch (offlineError) {
        console.error('Error loading offline KOT orders:', offlineError);
        store.dispatch(setKotOrderList([]));
        store.dispatch(setTableLoadingGlobal(false));
        store.dispatch(setIsLoading(false));
      }
    } else {
      // Server error (not network error)
      store.dispatch(setKotOrderList([]));
      store.dispatch(setTableLoadingGlobal(false))
      store.dispatch(setIsLoading(false));
      store.dispatch(
        setAlertMessage({
          status: alertMessages.ERROR,
          message: error.response.data || "Error occurred while fetching data!",
        })
      );
    }
  }
};

// KOT order action API with offline support
export const kotOrderActionAPI = async (obj) => {
  let endPoint;
  let kotStatus;
  let socketEvent;
  
  switch (obj.actionKeyName) {
    case actionKeyName.TOCOOK:
      endPoint = `kotStatusToCook`;
      kotStatus = 'COOKING';
      socketEvent = 'toKotCookStatus';
      break;
    case actionKeyName.REJECT:
      endPoint = ``;
      kotStatus = 'REJECTED';
      socketEvent = 'toKotRejectStatus';
      break;
    case actionKeyName.COMPLETED:
      endPoint = `kotStatusToCompleted`;
      kotStatus = 'COMPLETED';
      socketEvent = 'toKotCompleteStatus';
      break;
    case actionKeyName.DELIVERY:
      endPoint = `kotStatustoDelivered`;
      kotStatus = 'DELIVERED';
      socketEvent = 'toKotDeliveryStatus';
      break;
    case actionKeyName.ECOMMERCE_DELIVERED:
      endPoint = `kotStatusToDeliveredEcommerce`;
      kotStatus = 'DELIVERED';
      socketEvent = 'toKotDeliveryStatus';
      break;
    case actionKeyName.RESET:
      endPoint = `kotStatusResetToPreparing`;
      kotStatus = 'PENDING';
      socketEvent = 'toKotResetStatus';
      break;
    default:
      endPoint = ``;
      break;
  }

  try {
    store.dispatch(setIsLoading(true));
    const requestBody = {
      ...obj.body,
      postDate: obj.postDate
    };
    const response = await axios.post(`pos/${endPoint}`, requestBody, HEADERS);
    if (response.status === 200) {
      store.dispatch(setIsLoading(false));
    }
  } catch (error) {
    // If network error, update locally and emit via hybrid socket
    if (!error.response && kotStatus) {
      console.log(`📴 KOT: Backend offline, updating status locally to ${kotStatus}...`);
      try {
        // Update status in IndexedDB
        const orderId = obj.body.orderId || obj.body._id;
        await db.updateKotStatus(orderId, kotStatus);
        
        // Emit via hybrid socket (will use BroadcastChannel if offline)
        const hybridSocket = (await import('../../../offline/hybridSocket')).default;
        hybridSocket.emit(socketEvent, { orderId, kotStatus });
        
        store.dispatch(setIsLoading(false));
        store.dispatch(
          setAlertMessage({
            status: "success",
            message: `Status updated offline (will sync when online)`,
          })
        );
        console.log(`✅ KOT: Status updated offline and emitted via hybrid socket`);
      } catch (offlineError) {
        console.error('Error updating KOT status offline:', offlineError);
        store.dispatch(setIsLoading(false));
        store.dispatch(
          setAlertMessage({
            status: alertMessages.ERROR,
            message: "Failed to update status offline",
          })
        );
      }
    } else {
      // Server error (not network error)
      store.dispatch(setIsLoading(false));
      store.dispatch(
        setAlertMessage({
          status: alertMessages.ERROR,
          message: error.response?.data || "Error occurred while updating!",
        })
      );
    }
  }
};

//KOT side menu list api
export const kotSideMenuListApi = async (obj) => {
  try {
    store.dispatch(setIsLoading(true));
    const response = await axios.post(
      `pos/listProductCountInKot`,
      obj.body,
      HEADERS
    );
    if (response.status === 200) {
      store.dispatch(setIsLoading(false));
      store.dispatch(setSideMenuList(response.data));
    }
  } catch (error) {
    console.error(error)
    store.dispatch(setSideMenuList([]));
    store.dispatch(setIsLoading(false));
    store.dispatch(
      setAlertMessage({
        status: alertMessages.ERROR,
        message: error.response.data || "Error occurred ",
      })
    );
  }
};

//KOT side menu sort product list
export const viewKOTSortProductListAPI = async (obj) => {
  try {
    store.dispatch(setIsLoading(true));
    const response = await axios.post(
      `pos/viewKotOrdersWithProdFilter`,
      obj.body,
      HEADERS
    );
    if (response.status === 200) {
      store.dispatch(setIsLoading(false));
      store.dispatch(setKotOrderList(response.data));
    }
  } catch (error) {
    store.dispatch(setIsLoading(false));
    store.dispatch(
      setAlertMessage({
        status: alertMessages.ERROR,
        message: error.response.data || "Error occurred ",
      })
    );
  }
};

//KOT update single product status
export const updateSingleProductStatus = async (obj) => {
  try {
    const response = await axios.put(
      `pos/setEachProductToCompleted`,
      obj.body,
      HEADERS
    );
    if (response.status === 200) {
    }
  } catch (error) {
    console.error(error);
  }
};

//KOT update all order status 
export const updateAllOrderStatus = async (obj) => {
  const endpoints = {
    1: 'kotStatusToPreparingAll',
    2: 'kotStatusToCompleteAll',
    3: 'kotStatusToDeliveredAll'
  };

  const endpoint = endpoints[obj.index];
  try {
    const response = await axios.put(
      `pos/${endpoint}`,
      obj.body,
      HEADERS
    );
    if (response.status === 200) {
      obj.setPopup(false)
    }
  } catch (error) {
    console.error(error);
    store.dispatch(
      setAlertMessage({
        status: alertMessages.ERROR,
        message: error.response.data || "Error occurred ",
      })
    );
  }
};
